import { AppManifest } from "./app-manifest"

export function getMenuTitle(manifest: AppManifest) {
  return manifest.features.userAccounts ? "Account" : "Menu"
}
